<template>
  <div>
    <div id="goz_esnetme33">
      <paused
        v-if="pause"
        @click="
          $root.$emit('pause', !pause);
          pause = false;
        "
      ></paused>
      <a
        href="javascript:;"
        @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        "
        class="pause"
      >
        <i
          :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"
        ></i>
      </a>

      <div id="true" style="display: none">
        <i class="fas fa-check" style="font-size: 40px; color: green"></i>
      </div>
      <div id="false" style="display: none">
        <i class="fas fa-times" style="font-size: 40px; color: red"></i>
      </div>

      <div
        style="
          background-color: #fff;
          position: absolute;
          top: 0px;
          left: 0px;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          z-index: 91369192;
        "
        v-if="finished"
      >
        <div>{{ $t("module.point") }}: {{ point }}</div>
        <div>{{ $t("module.total_true") }}: {{ totalTrue }}</div>
        <div>{{ $t("module.total_false") }} {{ totalFalse }}</div>
        <div>
          {{ $t("module.isabet") }}
          {{ ((totalTrue / (totalTrue + totalFalse)) * 100).toFixed(1) }}%
        </div>
        <div>
          {{ $t("module.reaction") }}
          {{
            (
              reactions.reduce((i, y) => i + y, 0) /
              reactions.length /
              1000
            ).toFixed(2)
          }}
          {{ $t("module.seconds") }}
        </div>
        <el-button round type="primary" class="mt-3" @click="init">
          {{ $t("module.start_again") }}
        </el-button>
      </div>

      <h3
        style="
          position: absolute;
          top: 70px;
          font-size: 27px;
          text-align: center;
          color: white;
        "
        v-html="$t('module.hafizandatut.desc')"
      ></h3>

      <div
        v-if="started"
        style="
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 0;
          background-color: #ddd;
          padding: 5px 0px;
        "
      >
        <div
          style="
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: center;
          "
        >
          <strong>{{ $t("module.time") }}</strong
          >: 00:{{ counter }}
        </div>
        <div
          style="
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: center;
          "
        >
          <strong>{{ $t("module.point") }}</strong
          >: {{ point }}
        </div>
        <div
          style="
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: center;
          "
        >
          <strong>{{ $t("module.level") }}</strong
          >: {{ level }}
        </div>
      </div>

      <div
        v-if="started == false"
        style="
          width: 100px;
          height: 100px;
          position: absolute;
          background-color: #1c449c;
          border-radius: 50%;
          z-index: 99;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          box-shadow: 0px 0px 15px #1c449c;
          font-weight: bold;
          font-size: 22px;
          cursor: pointer;
        "
        @click="start"
      >
        {{ startCounter == 0 ? $t("module.start") : startCounter }}
      </div>

      <div>
        <div
          class="flip-card"
          :class="index > currentCardIndex ? 'picked' : ''"
          :key="i + index"
          v-for="(i, index) in stack"
        >
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 100%;
                "
              >
                <div
                  :style="{
                    backgroundColor: i == '100' ? '#1C449C' : '',
                    borderColor: i == '100' ? '#9292ff' : '#ddd',
                  }"
                  class="circle"
                  style="
                    width: 40px;
                    height: 40px;
                    border: 6px solid #ddd;
                    border-radius: 50%;
                  "
                ></div>
              </div>
              <div
                style="
                  width: 100%;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  justify-content: space-between;
                  margin-top: 20px;
                "
              >
                <div
                  :style="{
                    backgroundColor: i == '010' ? '#1C449C' : '',
                    borderColor: i == '010' ? '#9292ff' : '#ddd',
                  }"
                  class="circle"
                  style="
                    width: 40px;
                    height: 40px;
                    border: 6px solid #ddd;
                    border-radius: 50%;
                  "
                ></div>
                <div
                  :style="{
                    backgroundColor: i == '001' ? '#1C449C' : '',
                    borderColor: i == '001' ? '#9292ff' : '#ddd',
                  }"
                  class="circle"
                  style="
                    width: 40px;
                    height: 40px;
                    border: 6px solid #ddd;
                    border-radius: 50%;
                  "
                ></div>
              </div>
            </div>
            <div class="flip-card-back"></div>
          </div>
        </div>
      </div>

      <div style="position: absolute; bottom: 20px">
        <a
          href="javascript:;"
          style="
            padding: 10px 15px;
            border-radius: 10px;
            color: black;
            font-size: 19px;
          "
          @click="check({ keyCode: 37 })"
        >
          <span
            style="
              border: 1px solid #fff;
              width: 30px;
              display: inline-block;
              text-align: center;
              margin-right: 5px;
            "
          >
            <i class="fas fa-long-arrow-alt-left text-white"></i>
          </span>
          <span class="text-white">{{ $t("module.different") }}</span>
        </a>

        <a
          href="javascript:;"
          style="
            padding: 10px 15px;
            border-radius: 10px;
            color: black;
            font-size: 19px;
          "
          @click="check({ keyCode: 39 })"
        >
          <span class="text-white">{{ $t("module.same") }}</span>
          <span
            style="
              border: 1px solid #fff;
              width: 30px;
              display: inline-block;
              text-align: center;
              margin-right: 5px;
            "
          >
            <i class="fas fa-long-arrow-alt-right text-white"></i>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import axios from "axios";
import moment from "moment";
export default {
  name: "HafizandaTut",
  props: ["config"],
  data() {
    return {
      currentCardIndex: 199,
      shapes: ["100", "010", "001"],
      stack: [],
      level: 1,
      counter: 10,
      reactions: [],
      lastPickTime: new Date().getTime(),
      trueStack: 0,
      started: false,
      startCounter: 0,
      startInterval: null,
      point: 0,
      totalTrue: 0,
      totalFalse: 0,
      pause: false,
      finished: false,
    };
  },
  created() {
    this.init();
    if (this.config != null && this.config != undefined) {
      this.$root.$emit("pause", true);
    }
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme33").clientWidth,
      height: document.getElementById("goz_esnetme33").clientHeight,
    };

    window.addEventListener("keydown", this.check);
  },
  beforeDestroy() {
    clearInterval(this.interval);
    window.removeEventListener("keydown", this.check);
  },
  methods: {
    init() {
      if (
        this.config != null &&
        this.config != undefined &&
        this.config.getTime() < 60
      ) {
        this.$root.$emit("done", true);
        return;
      }

      this.lock = false;
      this.finished = false;
      this.started = false;
      this.counter = 60;
      this.reactions = [];
      this.level = 1;
      this.totalTrue = 0;
      this.totalFalse = 0;
      this.point = 0;
      this.currentCardIndex = 199;
      this.stack = [];
      var same = 0;
      var sameCounter = 0;
      for (let index = 0; index < 200; index++) {
        if (index == 0) {
          var ii = _.random(0, this.shapes.length - 1);
          this.stack.push(this.shapes[ii]);
          continue;
        }
        if (index > 0 && sameCounter > 0) {
          this.stack.push(this.stack[index - 1]);
          sameCounter -= 1;
        } else {
          if (_.random(0, 1) == 1) {
            sameCounter = _.random(1, 3);
          }
          var ii = _.random(0, this.shapes.length - 1);
          while (true) {
            if (this.shapes[ii] == this.stack[index - 1]) {
              ii = _.random(0, this.shapes.length - 1);
            } else {
              break;
            }
          }
          this.stack.push(this.shapes[ii]);
        }
      }
    },
    start() {
      this.startCounter = 3;
      this.startInterval = setInterval(() => {
        this.startCounter -= 1;
        if (this.startCounter == 0) {
          clearInterval(this.startInterval);
          this.started = true;
          this.start2();
        }
      }, 1000);
    },
    start2() {
      setTimeout(() => {
        this.$root.$emit("pause", false);
      }, 2000);
      this.currentCardIndex -= 1;
      this.lastPickTime = new Date().getTime();
      this.interval = setInterval(() => {
        this.counter -= 1;
        if (this.counter == 0) {
          clearInterval(this.interval);
          this.$root.$emit("pause", true);
          axios.post("module/savePoints", {
            points: [
              {
                point: this.point,
                type: "dikkat",
              },
            ],
            module_id: this.$store.state.modules.find(
              (k) => k.slug == "hafiza-ucgeni"
            ).module_id,
          });

          axios.post("module/savePoints", {
            points: [
              {
                point:
                  this.reactions.reduce(
                    (counter, item) => (item += counter),
                    0
                  ) / this.reactions.length,
                type: "tepki",
              },
            ],
            module_id: this.$store.state.modules.find(
              (k) => k.slug == "hafiza-ucgeni"
            ).module_id,
          });

          this.finished = true;
        }
      }, 1000);
    },
    check(e) {
      if (this.started == false || this.lock || this.finished) return;
      this.lock = true;
      const keyCode = parseInt(e.keyCode || e.code || e.keyIdentifier);
      var card = this.stack[this.currentCardIndex];
      var prevCard = this.stack[this.currentCardIndex + 1];
      switch (keyCode) {
        case 37:
          if (card != prevCard) {
            this.totalTrue += 1;
            this.point += this.level * 50;
            this.trueStack += 1;
            if (this.$store.state.selectedTick2 != "sessiz")
              new Audio("/static/correct.mp3").play();
            this.reactions.push(new Date().getTime() - this.lastPickTime);
            this.lastPickTime = new Date().getTime();
          } else {
            this.totalFalse += 1;
            if (this.trueStack == 0) {
              this.level = Math.max(this.level - 1, 1);
            } else {
              this.trueStack -= 1;
            }
            if (this.$store.state.selectedTick2 != "sessiz")
              new Audio("/static/incorrect.mp3").play();
          }

          this.currentCardIndex -= 1;
          setTimeout(() => {
            $(".picked").css("z-index", 1);
          }, 300);

          break;

        case 39:
          if (card == prevCard) {
            this.totalTrue += 1;
            this.point += this.level * 50;
            this.trueStack += 1;
            if (this.$store.state.selectedTick2 != "sessiz")
              new Audio("/static/correct.mp3").play();
            this.reactions.push(new Date().getTime() - this.lastPickTime);
            this.lastPickTime = new Date().getTime();
          } else {
            this.totalFalse += 1;
            if (this.trueStack == 0) {
              this.level = Math.max(this.level - 1, 1);
            } else {
              this.trueStack -= 1;
            }
            if (this.$store.state.selectedTick2 != "sessiz")
              new Audio("/static/incorrect.mp3").play();
          }

          this.currentCardIndex -= 1;
          setTimeout(() => {
            $(".picked").css("z-index", 1);
          }, 300);

          break;

        default:
          break;
      }
      setTimeout(() => {
        this.lock = false;
      }, 500);
    },
    next() {
      this.colors = {
        0: null,
        1: null,
      };
      this.options =
        this.levels[this.level - 1][
          _.random(0, this.levels[this.level - 1].length - 1)
        ];
      setTimeout(() => {
        this.lock = false;
      }, 400);
    },
  },
  watch: {
    trueStack: function (neww, old) {
      if (this.trueStack == 5 && old != 0) {
        this.level += 1;
      }
    },
    totalTrue: function () {
      $("#true").show();
      setTimeout(() => {
        $("#true").hide();
      }, 400);
    },
    totalFalse: function () {
      $("#false").show();
      setTimeout(() => {
        $("#false").hide();
      }, 400);
    },
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme33 {
  width: 700px;
  max-width: 700px;
  height: 470px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  background-image: url("/static/img/bgg.jpg") !important;
  flex-direction: column;
  background-size: 100%;

  .flip-card {
    background-color: transparent;
    width: 200px;
    height: 200px;
    perspective: 1000px;
    position: absolute;
    left: 375px;
    transition: 1s;
    top: 180px;
    z-index: 2;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  .flip-card.picked {
    left: 325px;
    transition: 1s;
  }

  .flip-card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 0.8s;
    transform-style: preserve-3d;
  }

  .flip-card.picked .flip-card-inner {
    transform: rotateY(-180deg);
    transform-origin: left;
  }

  .flip-card-front,
  .flip-card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden; /* Safari */
    backface-visibility: hidden;
    border-radius: 20px;
    border: 4px solid #ddd;
  }

  .flip-card-front {
    background-color: #fff;
    color: black;
    padding: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .flip-card-back {
    background-color: #fff;
    color: white;
    transform: rotateY(-180deg);
    background: url(/static/img/card.png);
    background-size: 100%;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/modules/HafizandaTut.vue